<template>
    <div class="Index">
        <div class="topHeader">
            <layout-header></layout-header>
        </div>
        <div class="main">
            <layout-nav></layout-nav>
            <div class="right">
                <div class="content">
                    <p></p>
                    <div class="tag-view tec-lf">
                        <el-tag
                                v-for="(item,index) in routerList"
                                :key="index"
                                :closable=" item.name=='home'? false: true "
                                :class="activeUrl==item.path? 'activeUrl':'' "
                                @click="gotoActiveUrl(item.path)"
                                @close="handleClose(item,index)">
                            {{item.title}}
                        </el-tag>

<!--                        <el-tabs>-->
<!--                          -->
<!--                            <el-tab-pane  v-for="(item,index) in routerList"-->
<!--                                          :key="index"-->
<!--                                          :closable=" item.name=='home'? false: true "-->
<!--                                          :class="activeUrl==item.path? 'activeUrl':'' "-->
<!--                                          @click="gotoActiveUrl(item.path)"-->
<!--                                          @close="handleClose(item,index)"-->
<!--                            >-->
<!--                                {{item.title}}-->
<!--                            </el-tab-pane>-->
<!--                        </el-tabs>-->
                    </div>
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //loyout布局
    import LayoutHeader from "@/components/Header"
    import LayoutNav from "@/components/LeftMenu"
    import { mapState } from "vuex"
    import {mapActions} from "vuex"
    export default {
        name: 'Index',
        components:{
            LayoutHeader,
            LayoutNav
        },
        data(){
            return{
                activeUrl:"/home"
            }
        },
        watch:{
            $route(to){
                this.activeUrl = to.path;
                this.isLogin();
                // console.log(to,"ac")
            }

        },
        mounted() {
            this.isLogin();
        },
        computed:{
            ...mapState(["routerList"])
        },
        methods: {
            ...mapActions(["delView","delVisitedView", "getSysPonsitionMenuOperation","getCurrentMenuId"]),
            delectView(view){
                this.delView(view);
            },
            gotoActiveUrl(value) {
                this.$router.push({path: value})

            },
            handleClose(value,index) {
                console.log("11",this.$router)
                let that=this;
                that.delectView(value)
                let one={};
                let length=that.routerList.length;
                for (let i=0;i<that.routerList.length;i++){
                    if(index==i && index==that.routerList.length){
                         one=that.routerList[i-1];
                    }else {
                        one=that.routerList[length-1];
                    }
                }
                this.$router.push({path: one.path})
            },
            async isLogin() {
                if (!sessionStorage.getItem('loginuser')) {
                    setTimeout(() => {
                        this.$router.push({ path: "/login" });
                    }, 500);
                } else{
                    await this.getSysPonsitionMenuOperation(); // 获取菜单列表
                    await this.haveAuthority(); // 判断是否有页面权限
                }

            },
            //判断是否有页面权限
            async haveAuthority() {
                let routeWhiteList = ["/home", "/login"]; // 路由白名单
                if (!routeWhiteList.includes(this.$route.path)) {
                    // 不在白名单的 需要判断是否拥有权限
                    let result = await this.getCurrentMenuId({ path: this.$route.path });
                    if (!result.state) {
                        this.$message({
                            type: "warning",
                            message: "你没有当前页面的权限",
                        });
                        this.$router.push({ path: "/home" });
                    }
                }
            },
        }
    }
</script>
<style  lang="scss" scoped>

    .Index{
        /*overflow: hidden;*/
    }
    .tec-lf{
        text-align: left;
    }
    .content{
        padding: 20px;
        background-color: #fff;
    }
    .tag-view{
        border-bottom:1px solid #ececec;
        /deep/{
            .el-tag{
                display: inline-block;
                background-color: #EEEEEE;
                height: 38px;
                line-height: 38px;
                padding: 0 14px;
                cursor: pointer;
                color: #333;
                border-color: #e8e1e1;
                border-radius: 0;
                .el-tag__close{
                    color: #000;
                }
            }
            .activeUrl{
                background-color: #fff;
                color: #3e82e8;
            }
        }
    }
    .topHeader{
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
    }
    .main{
        margin-top: 60px;
        background-color:#f2f2f2;
        padding-top: 10px;
        display: flex;
        .right{
            /*border: 1px solid red;*/
            margin:3px 10px ;
            height: calc(100vh - 100px);
            width: calc(100% - 200px);
            overflow-y: auto;
        }
    }

</style>